// ============================================================================
// TAXONOMIA V12 — REFATORADA EM 30/04/2026 A PARTIR DA ARVORE DE CATEGORIAS DO BLING
// Extraída de PersonalFinance.jsx para reuso em service layer + scripts Node.js
// Decisao registrada em: diario_financeiro/2026/04/2026-04-30_taxonomia-pf-8-generos.md
// ============================================================================

export const DEFAULT_CATEGORIES = {
  RECEITAS: {
    label: "💰 RECEITAS",
    color: "text-green-700 bg-green-50 border-green-200",
    subs: [
      "Retirada de Sócio",
      "Salário Líquido",
      "Pró-labore Recta Scripta",
      "Renda Extra",
      "Reembolsos",
      "Dividendos",
      "Resgate de Aplicação",
    ],
    budget: 0,
  },
  MORADIA: {
    label: "🏠 MORADIA",
    color: "text-amber-800 bg-amber-50 border-amber-200",
    subs: [
      "Aluguel / Condomínio",
      "Energia Elétrica",
      "Internet",
      "Telefone Fixo",
      "Celular",
      "Gás de Cozinha",
      "Diarista",
      "Reforma & Móveis",
    ],
    budget: 4000,
  },
  ALIMENTACAO: {
    label: "🍽️ ALIMENTAÇÃO",
    color: "text-yellow-700 bg-yellow-50 border-yellow-200",
    subs: [
      "Mercado",
      "Feira / Açougue",
      "Peixaria",
      "Casa do Queijo",
      "Restaurante",
      "PopHouse",
      "Avulsos",
    ],
    budget: 2500,
  },
  TRANSPORTE: {
    label: "🚗 TRANSPORTE",
    color: "text-slate-700 bg-slate-50 border-slate-200",
    subs: [
      "Financiamento Spin",
      "Financiamento Volvo",
      "Combustível",
      "Oficina (Mecânico/Manutenção)",
      "Itens do Carro",
      "Seguro do Carro",
      "Estacionamento",
      "Uber",
    ],
    budget: 3500,
  },
  SAUDE: {
    label: "⚕️ SAÚDE",
    color: "text-red-700 bg-red-50 border-red-200",
    subs: [
      "Unimed",
      "Amil Dental",
      "Óculos",
      "Terapia",
      "Pilates",
      "Academia",
      "Nutricionista",
      "Suplementos",
      "Forxiga 10mg",
      "Glifage XR 500mg",
      "Cloridrato de Fexofenatina 120mg",
      "Rosucor 10mg",
      "Alopurinol 300mg",
      "Donaren Retard 150mg",
      "Rivotril 2mg",
      "Selozok 50mg",
      "Prysma 3mg",
      "Remédio Avulso",
    ],
    budget: 3000,
  },
  PETS: {
    label: "🐶 PETS",
    color: "text-orange-700 bg-orange-50 border-orange-200",
    subs: [
      "Alimentação Natural",
      "Ração",
      "Remédio Pet",
      "Veterinário",
      "Banho / Tosa",
      "Hotelzinho",
    ],
    budget: 1200,
  },
  ESTILO: {
    label: "🎬 ESTILO DE VIDA",
    color: "text-purple-700 bg-purple-50 border-purple-200",
    subs: [
      "Streaming",
      "Assinaturas & Ferramentas Online",
      "Cuidados Pessoais",
      "Viagem",
      "Faculdade",
      "Vestuário",
      "Lazer",
    ],
    budget: 1500,
  },
  FUTURO: {
    label: "🎯 PROJETOS & METAS",
    color: "text-blue-700 bg-blue-50 border-blue-200",
    subs: [
      "Reserva de Emergência",
      "Aposentadoria",
      "Fundo de Viagem",
      "Troca de Carro",
      "Reserva de Recomeço",
    ],
    budget: 2000,
  },
  FAMILIA: {
    label: "🏡 FAMÍLIA",
    color: "text-teal-700 bg-teal-50 border-teal-200",
    subs: ["Acordo Herança Pai", "Reembolso Eliane", "Apoio Familiar"],
    budget: 0,
  },
};

// Nomes dos grupos (para iteração)
export const GROUP_NAMES = Object.keys(DEFAULT_CATEGORIES);

// Verifica se uma category pertence ao group indicado
export function isValidCategory(group, category) {
  const g = DEFAULT_CATEGORIES[group];
  if (!g) return false;
  return g.subs.includes(category);
}
